import {
  JobTaxAssistant,
  JobTaxAssistantReplyStatus,
} from '@taxfyle/api-internal/internal/job_tax_assistant_pb'
import { timestampToISO } from 'utils/grpc-util'

export interface JobTaxAssistantDTO {
  job_id: string
  active: boolean
  reply_status: 'IDLE' | 'PROCESSING'
  external_reply_id: string | undefined
  update_time: string | undefined
}

export function mapJobtaxAssistantProtoToDTO(
  proto: JobTaxAssistant,
): JobTaxAssistantDTO {
  return {
    job_id: proto.getJobId(),
    reply_status: mapJobTaxAssistantReplyStatusProto(proto.getReplyStatus()),
    active: proto.getActive(),
    external_reply_id: proto.getExternalReplyId()?.getValue(),
    update_time: timestampToISO(proto.getUpdateTime()),
  }
}

function mapJobTaxAssistantReplyStatusProto(proto: JobTaxAssistantReplyStatus) {
  switch (proto) {
    case JobTaxAssistantReplyStatus.JOB_TAX_ASSISTANT_REPLY_STATUS_UNSPECIFIED:
      return 'IDLE'
    case JobTaxAssistantReplyStatus.IDLE:
      return 'IDLE'
    case JobTaxAssistantReplyStatus.PROCESSING:
      return 'PROCESSING'
  }
}
